<template>
  <b-modal id="modal-delete-fleet" class="mc-modal" title="Hapus" size="md" centered scrollable>
    <div class="card-body mc-modal__filter p-2">
      <p>{{ $t('global.confirmDelete1') }} {{ $t('global.confirmDelete2') }}</p>
      <b-list-group>
        <b-list-group-item v-for="item in selectedVehicles" :key="item.id">
          {{ item.licensePlate }}
        </b-list-group-item>
      </b-list-group>
    </div>
    <template #modal-footer="{ cancel }">
      <b-row class="mc-modal__filter-footer mx-0">
        <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
          <b-button class="me-2" variant="outline-primary" @click="cancel()">
            {{ $t('global.no') }}
          </b-button>
          <b-button variant="primary" @click="$emit('deleteVehicleIds')">
            {{ $t('global.yes') }}
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    selectedVehicles: {
      type: Array,
      required: true
    }
  },
  emits: ['deleteVehicleIds']
}
</script>